export const Divider = () => <hr className="opacity-20 border-black" />;
